import {
  IconZoomInArea,
  IconZoomCheck,
  IconZoomExclamation,
  IconEye,
  IconEyeSearch,
  IconEyeCheck,
  IconScanEye,
  IconClipboardList,
} from "@tabler/icons-react";
import type React from "react";

export interface NavItem {
  value: string;
  label: string;
  icon: React.ReactNode;
  adminOnly?: boolean;
}

export interface NavSection {
  title: string;
  items: NavItem[];
}

export const NAV_SECTIONS: NavSection[] = [
  {
    title: "QC Tasks",
    items: [
      {
        value: "my-tasks",
        label: "My Tasks",
        icon: <IconClipboardList size={18} />,
        adminOnly: true,
      },
      {
        value: "confirmation",
        label: "Confirmation Jobs",
        icon: <IconZoomInArea size={18} />,
      },
      { value: "coverage", label: "Coverage", icon: <IconEye size={18} /> },
    ],
  },
  {
    // Whole section is visible only when the fe_enable_oos_benchmark_quiz
    // gate is on (items filtered in GlobalNav; empty sections don't render).
    title: "Benchmarking",
    items: [
      {
        value: "my-quizzes",
        label: "My Quizzes",
        icon: <IconZoomCheck size={18} />,
      },
      {
        value: "benchmark-admin",
        label: "Manage Quizzes",
        icon: <IconClipboardList size={18} />,
        adminOnly: true,
      },
    ],
  },
  {
    title: "QA Tasks",
    items: [
      {
        value: "confirmation-qa",
        label: "Confirmation QA",
        icon: <IconZoomExclamation size={18} />,
        adminOnly: true,
      },
      {
        value: "coverage-qa",
        label: "Coverage QA",
        icon: <IconEyeSearch size={18} />,
        adminOnly: true,
      },
      {
        // Also gated on useCoverageBetaEnabled in GlobalNav (alongside the
        // benchmarkEnabled special case) — this array has no per-item hook
        // for a second gate.
        value: "coverage-beta-qa",
        label: "Coverage Beta QA",
        icon: <IconEyeSearch size={18} />,
        adminOnly: true,
      },
      {
        value: "confirmation-qa-feedback",
        label: "QA Feedback",
        icon: <IconClipboardList size={18} />,
      },
    ],
  },
  {
    title: "Admin Views",
    items: [
      {
        value: "admin-confirmation",
        label: "Admin Confirmation",
        icon: <IconZoomCheck size={18} />,
        adminOnly: true,
      },
      {
        value: "admin-coverage",
        label: "Admin Coverage",
        icon: <IconEyeCheck size={18} />,
        adminOnly: true,
      },
      {
        value: "admin-coverage-qa",
        label: "Admin Coverage QA",
        icon: <IconScanEye size={18} />,
        adminOnly: true,
      },
      {
        // Also gated on useCoverageBetaEnabled in GlobalNav — see above.
        value: "admin-coverage-beta-qa",
        label: "Admin Coverage Beta QA",
        icon: <IconScanEye size={18} />,
        adminOnly: true,
      },
    ],
  },
];
